const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"382de62c5d10bbec31426055b51f9a94fd58d8fe"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["front@saweria"]={id:"382de62c5d10bbec31426055b51f9a94fd58d8fe"};
      